export function validateDomain(email, orgData) {
    const domain = email.split("@")[1].toLowerCase();
	return orgData?.sso?.domains.includes(domain)
}